// Converted to typescript through help of ChatGPT

import * as types from './documentsTypes';

export function transformDocumentToRequestData(document: types.Document) {
  return {
    id: document.id,
    isDeleted: document.isDeleted,
    name: document.name,
    description: document.description,
    documentType: document.documentType,
    contentType: document.contentType,
    clientId: document.clientId,
    url: document.url,
    size: document.documentSize,
  };
}

export function transformResponseToDocuments(response: any) {
  // Typing doesn't matter since it will turn into a Document type
  return response.data.resources.map((data: types.DocumentProps) => transformDataToDocument(data));
}

export function transformDataToDocument(data: any) {
  return types.mkDocument({
    id: data.id,
    isDeleted: data.isDeleted,
    name: data.name,
    description: data.description,
    documentType: data.documentType,
    contentType: data.contentType,
    clientId: data.clientId,
    url: data.url,
    documentSize: data.size,
  });
}

export function transformDocumentWithResponse(document: types.Document, response: any) {
  return document.merge({
    id: response.data.id || document.id,
    ...(response.data.url && { url: response.data.url }),
  });
}
